// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"869":"styles","975":"component---src-templates-default-tsx"}[chunkId] + "-" + {"869":"7880f47251e670f57e9e","975":"d59b26e83733a10f96d4"}[chunkId] + ".js";
};